import { createSelector } from 'reselect';

import { POWERBI_RIGHT_TO_ACCESS_IMPORT } from '../constants/PowerBIConstants';

export const getImportRecords = (state) => state.powerBI.importRecords;

export const getDatasetList = (state) => state.powerBI.datasetList;
export const getReportsList = (state) => state.powerBI.reportsList;
export const getCurrentRecordId = (state) => state.powerBI.currentRecordId;
export const getCreateReportData = (state) => state.powerBI.createReportData;
export const getIsPowerBIImportModalOpen = (state) => state.powerBI.isImportModalOpen;
export const getIsExportPending = (state) => state.powerBI.isExportPending;
export const getRefreshDate = (state) => state.powerBI.refreshDate;

export const getIsImportAvailable = (state) =>
  state.userRights.includes(POWERBI_RIGHT_TO_ACCESS_IMPORT);

export const getImportRecordProp = (propName) =>
  createSelector(
    [getImportRecords, getCurrentRecordId],
    (importRecords, currentRecordId) => importRecords[currentRecordId]?.[propName]
  );
